function Morocco({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1701)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
  <path d="M25.4555 13.1305H18.2322L16.0001 6.26074L13.7679 13.1305H6.54456L12.3884 17.3762L10.1562 24.2462L16.0001 20.0004L21.8439 24.2462L19.6117 17.3763L25.4555 13.1305ZM14.0239 16.8448L14.7787 14.5217H17.2213L17.9762 16.8448V16.8449L16.0001 18.2805L14.024 16.8449L14.0239 16.8448ZM16.7693 13.1305H15.2309L16.0001 10.763L16.7693 13.1305ZM19.1596 15.985L18.6842 14.5218H21.1735L19.1596 15.985ZM13.3159 14.5218L12.8404 15.985L10.8265 14.5218H13.3159ZM12.8026 20.6037L13.5719 18.2362L14.8166 19.1405L12.8026 20.6037ZM17.1836 19.1405L18.4282 18.2363L19.1975 20.6037L17.1836 19.1405Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Morocco;
